const login = {
   // seems to be deprecated >> see public/conf/login-messages.js
   useKeycloak: false,
   maintenance: {
    show: false,
    html: '<p><u>Bitte beachten Sie:</u></p><p>Aufgrund von Wartungsarbeiten steht der Online-Campus am Samstag, den 20.07.2019, zwischen 10:00 und 16:00 Uhr nicht zur Verfügung.</p><p>Wir bitten Sie, entstehende Unannehmlichkeiten zu entschuldigen. </p>'
   },
   footer: [{
     label: 'APOLLON Hochschule',
     uri: 'http://www.apollon-hochschule.de/',
     target: '_blank'
   }, {
     label: 'Datenschutzerklärung',
     uri: 'https://www.apollon-campus.de/c/datenschutz',
     target: '_blank'
   }, {
     label: 'Impressum',
     uri: 'http://www.apollon-hochschule.de/impressum/',
     target: '_blank'
   }]
}
export default { login }
